import React, { useEffect, useState } from "react";
import * as api from "../../services/api/work";
import SelectBase from "./SelectBase";
import { AxiosResponse } from "axios";

interface Props extends SelectType<WorkFormValues> {
  client: number;
  request: () => Promise<AxiosResponse<ClientFormValues[]>>;
}

const SelectWork: React.FC<Props> = props => {
  const [items, setItems] = useState<WorkFormValues[]>([]);

  useEffect(() => {
    getItems();
  }, [props.client]);

  const getItems = () => {
    api.getWorks().then(({ data }) => setItems(data));
  };

  const options = () => {
    return items
      .filter(item => item.client && item.client.id === props.client)
      .map(item => ({ value: item.id, label: item.name }));
  };

  return (
    <SelectBase
      options={options()}
      placeholder="Obra..."
      onClick={props.onChange}
      newItem={props.newItem}
      deletedItem={props.deletedItem}
      updatedItem={props.updatedItem}
      getItems={getItems}
      {...props}
    />
  );
};

export default SelectWork;
